/**
 * Included items land on the trip at booking. Add-ons stay off it until bought.
 * MySQL TINYINT comes through as 0/1, so do not use `!== false`.
 */
export const isIncludedPackageItem = (item) => {
  if (!item) return true;
  const flag = item.is_included;
  return flag !== false && flag !== 0 && flag !== '0';
};

export const packageAddOnItems = (items) => (
  (Array.isArray(items) ? items : []).filter((item) => !isIncludedPackageItem(item))
);

export const MAX_PACKAGE_ADDON_QUANTITY = 20;

export const addOnAmount = (item) => {
  const extra = Number(item?.additional_cost);
  if (Number.isFinite(extra) && extra > 0) return extra;
  const cost = Number(item?.cost);
  return Number.isFinite(cost) && cost > 0 ? cost : 0;
};

export const clampAddOnQuantity = (value) => {
  const quantity = Math.floor(Number(value) || 0);
  if (!Number.isFinite(quantity) || quantity <= 0) return 0;
  return Math.min(MAX_PACKAGE_ADDON_QUANTITY, quantity);
};

/** `{ [itemId]: quantity }` → checkout payload rows (qty > 0 only). */
export const addOnSelectionsPayload = (quantities = {}) => (
  Object.entries(quantities)
    .map(([id, quantity]) => ({
      id: Number(id),
      quantity: clampAddOnQuantity(quantity),
    }))
    .filter((entry) => Number.isInteger(entry.id) && entry.id > 0 && entry.quantity > 0)
);

export const selectedAddOnTotal = (addOns, quantities = {}) => (
  (addOns || []).reduce((sum, item) => {
    const quantity = clampAddOnQuantity(quantities[item.id] ?? quantities[String(item.id)]);
    if (quantity <= 0) return sum;
    return sum + addOnAmount(item) * quantity;
  }, 0)
);
